import React from "react";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

// Chakra imports
import { Flex, useColorModeValue, Image } from "@chakra-ui/react";
import illustration from "assets/img/layout/app_logo.png";


// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <NavLink to='/admin/default'><Image src={illustration} height={"120px"} paddingBottom={5}></Image></NavLink>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
